import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase'; // Import db
import { collection, getDocs } from 'firebase/firestore'; // Import firestore functions
import HeroImage from "../assets/Hero.jpg";
import Reviews from '../components/Reviews';

const Home = () => {
  const [clients, setClients] = useState({
    artistes: [],
    choirs: [],
    producers: [],
    organizations: []
  });
  const [loading, setLoading] = useState(true);

  // State to track which lists are expanded
  const [expandedCards, setExpandedCards] = useState({
    artistes: false,
    choirs: false,
    producers: false,
    organizations: false
  });

  // Limit of items to show before clicking "View More"
  const LIST_LIMIT = 5; 

  // Fetch live client data from Firebase
  useEffect(() => {
    const fetchClients = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "clients"));
        const data = querySnapshot.docs.map(doc => doc.data());
        
        // Group them by category
        setClients({
          artistes: data.filter(item => item.category === 'ARTISTES'),
          choirs: data.filter(item => item.category === 'CHOIRS'),
          producers: data.filter(item => item.category === 'PRODUCERS'),
          organizations: data.filter(item => item.category === 'ORGANIZATIONS'),
        });
        setLoading(false);
      } catch (error) {
        console.error("Error fetching clients: ", error);
        setLoading(false);
      }
    };

    fetchClients();
  }, []);

  // Function to toggle expanded state
  const toggleExpand = (category) => {
    setExpandedCards(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  return (
    <section>
      {/* Hero Section */}
      <div className="hero">
        <div className="left">
          <h1>We craft vocals that tell your story</h1>
          <p className="lead">
            Music is a language: let us speak for you; let us help you speak it!!
          </p>
          <div className="btn-group">
            <Link className="btn" to="/our-works">Sound Gallery</Link>
            <Link className="btn secondary" to="/contact">Get In Touch</Link>
          </div>
        </div>

        {/* Why Choose Us Card */}
          <div className="card center-card">
            <img
              src={HeroImage}
              alt="Why Choose Us"
              style={{ width: 400, height: 400, objectFit: "cover", borderRadius: "90px" }}
            />
            <div style={{ marginTop: 12 }}>
              <div style={{ fontWeight: 700, fontSize: "20px" }}>Why choose us?</div>
              <div style={{ color: "var(--muted)", marginTop: 6, marginBottom: 12 }}>
                Discover what makes us unique
              </div>
              <Link to="/why-choose-us" className="btn">
                Find Out
              </Link>
            </div>
          </div>
      </div>

      {/* What we do */}
      <section style={{ marginTop: 28 }}>
        <h2>What we do</h2>
        <div className="card-grid">
          {[
            "Vocal Training and/or Coaching",
            "Vocal arrangement & Scoring",
            "Live Concert bgvs",
            "Vocal Production",
            "Music Direction",
            "Song Writing",
            "Overdubs",
          ].map((item, i) => (
            <div key={i} className="card center-card whatwedo-card">
              <strong>{item}</strong>
            </div>
          ))}
        </div>
      </section>

      {/* Who have we worked for */}
      <section style={{ marginTop: 28 }}>
        <h2>Who have we worked for?</h2>
        {loading ? (
          <p>Loading portfolio...</p>
        ) : (
          <div className="card-grid" style={{ alignItems: 'flex-start' }}>
            {/* Artistes */}
            <div className="card red-card whoworked-card" style={{ height: 'fit-content', alignSelf: 'flex-start' }}>
              <h3 className="card-title">ARTISTES</h3>
              <div className="card-list">
                {(expandedCards.artistes ? clients.artistes : clients.artistes.slice(0, LIST_LIMIT)).map((artiste, index) => (
                  <div key={index} style={{ marginBottom: '4px' }}>
                    {index + 1}. {artiste.name} <span style={{ fontSize: '1.2em', marginLeft: '4px' }}>{artiste.flag}</span>
                  </div>
                ))}
                {clients.artistes.length === 0 && <p>No artistes listed yet.</p>}
                
                {clients.artistes.length > LIST_LIMIT && (
                  <button 
                    onClick={() => toggleExpand('artistes')} 
                    style={{ background: 'transparent', border: 'none', color: 'inherit', textDecoration: 'underline', cursor: 'pointer', padding: 0, marginTop: '10px', fontWeight: 'bold' }}
                  >
                    {expandedCards.artistes ? 'View Less' : 'View More'}
                  </button>
                )}
              </div>
            </div>

            {/* Choirs */}
            <div className="card red-card whoworked-card" style={{ height: 'fit-content', alignSelf: 'flex-start' }}>
              <h3 className="card-title">CHOIRS</h3>
              <div className="card-list">
                {(expandedCards.choirs ? clients.choirs : clients.choirs.slice(0, LIST_LIMIT)).map((choir, index) => (
                  <div key={index} style={{ marginBottom: '4px' }}>
                    {index + 1}. {choir.name}
                  </div>
                ))}
                {clients.choirs.length === 0 && <p>No choirs listed yet.</p>}

                {clients.choirs.length > LIST_LIMIT && (
                  <button 
                    onClick={() => toggleExpand('choirs')} 
                    style={{ background: 'transparent', border: 'none', color: 'inherit', textDecoration: 'underline', cursor: 'pointer', padding: 0, marginTop: '10px', fontWeight: 'bold' }}
                  >
                    {expandedCards.choirs ? 'View Less' : 'View More'}
                  </button>
                )}
              </div>
            </div>

            {/* Producers */}
            <div className="card dark-red-card whoworked-card" style={{ height: 'fit-content', alignSelf: 'flex-start' }}>
              <h3 className="card-title">PRODUCERS</h3>
              <div className="card-list">
                {(expandedCards.producers ? clients.producers : clients.producers.slice(0, LIST_LIMIT)).map((producer, index) => (
                  <div key={index} style={{ marginBottom: '4px' }}>
                    {index + 1}. {producer.name}
                  </div>
                ))}
                {clients.producers.length === 0 && <p>No producers listed yet.</p>}

                {clients.producers.length > LIST_LIMIT && (
                  <button 
                    onClick={() => toggleExpand('producers')} 
                    style={{ background: 'transparent', border: 'none', color: 'inherit', textDecoration: 'underline', cursor: 'pointer', padding: 0, marginTop: '10px', fontWeight: 'bold' }}
                  >
                    {expandedCards.producers ? 'View Less' : 'View More'}
                  </button>
                )}
              </div>
            </div>

            {/* Organizations */}
            <div className="card org-card whoworked-card" style={{ height: 'fit-content', alignSelf: 'flex-start' }}>
              <span className="org-label">ORGANIZATIONS</span>
              <div className="card-list" style={{ marginTop: "20px" }}>
                {(expandedCards.organizations ? clients.organizations : clients.organizations.slice(0, LIST_LIMIT)).map((org, index) => (
                  <div key={index} style={{ marginBottom: '4px' }}>
                    {index + 1}. {org.name}
                  </div>
                ))}
                {clients.organizations.length === 0 && <p>No organizations listed yet.</p>}

                {clients.organizations.length > LIST_LIMIT && (
                  <button 
                    onClick={() => toggleExpand('organizations')} 
                    style={{ background: 'transparent', border: 'none', color: 'inherit', textDecoration: 'underline', cursor: 'pointer', padding: 0, marginTop: '10px', fontWeight: 'bold' }}
                  >
                    {expandedCards.organizations ? 'View Less' : 'View More'}
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </section>

      {/* REVIEWS SECTION */}
      <Reviews />

    </section>
  );
};

export default Home;